import { Star } from 'lucide-react';

type Aggregate = {
  count: number;
  average: number;
  histogram: Record<string, number>;
};

export default function RatingHistogram({ aggregate }: { aggregate: Aggregate }) {
  const total = aggregate.count;
  if (total === 0) {
    return (
      <div className="text-sm text-muted-foreground">No reviews yet.</div>
    );
  }

  // Render bars from 5 down to 1
  const rows = [5, 4, 3, 2, 1].map((n) => {
    const c = aggregate.histogram[String(n)] ?? 0;
    const pct = Math.round((c / total) * 100);
    return { n, c, pct };
  });

  return (
    <div className="flex flex-col sm:flex-row gap-4 sm:items-center">
      <div className="flex items-baseline gap-2">
        <span className="text-3xl font-semibold tabular-nums">
          {aggregate.average.toFixed(1)}
        </span>
        <Star className="h-5 w-5 fill-current" strokeWidth={1.75} />
        <span className="text-sm text-muted-foreground">
          {total.toLocaleString()} review{total === 1 ? '' : 's'}
        </span>
      </div>
      <div className="flex-1 max-w-md space-y-1">
        {rows.map((r) => (
          <div key={r.n} className="flex items-center gap-2 text-xs">
            <span className="w-3 text-right tabular-nums text-muted-foreground">{r.n}</span>
            <div className="flex-1 h-2 rounded-full bg-muted overflow-hidden">
              <div className="h-full bg-foreground/40" style={{ width: `${r.pct}%` }} />
            </div>
            <span className="w-8 text-right tabular-nums text-muted-foreground">{r.c}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
